import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { handleFetchMessages, handleGetTempMsgData, handleGetUpdatedMsgData, handleReadAllMsg, requestCreateGroupWithmember, requestGetAllAcountLevelMember, requestGetArchiveGroupList, requestGetGroupRecipient, requestallmemberswithgroups, requestgroupMemberDetails, } from "../appStore/actions/ArkchatGroup/action";
import { getProfile } from "../appStore/actions/profile/action";
import { AccountLevelArkchatPermission, MessageType } from "../utils/constant";
import { getAlltopic } from "../appStore/actions/topics/action";
import { getAllSubtopicsForGroup } from "../appStore/actions/subtopics/action";
import { handleAccountSwitchLoading, handleAppSelectedTopic, handleAppSelectedTopicToSaveMsg, handleAppSelectedSubtopic, handleAppSelectedSubtopicToSaveMsg, handleAppSelectedThread, handleChangeTopicOpen, handleHomeTabValue, handleScrollToBottom, handleShowAIScreen, handleThreadListPanel, saveSelectedAppGroupData } from "../appStore/actions/AppState/action";
import useAppSelectors from "./useAppSelectors";

const useChatState = ({
  setisTopicOpen,
  isTopicOpen,
  groupname,
  setGroupname,
}) => {
  const [isSyncing, setSyncing] = useState(false);
  const [isCreategroupOpen, setCreategroupopen] = useState(false);
  const [isRequired, setRequired] = useState(false);
  const [dmUserDeatils, setDMuserDetails] = useState(null);
  const dispatch = useDispatch();
  const [isMoveTopicTriggered, setMoveTopicTriggered] = useState(false);
  const [moveTopicMsgId, setMoveTopicMsgId] = useState(null);
  const [isPermissionModalOpen, setPermissionModal] = useState(false);
  const [newMessages, setNewMessages] = useState("");
  const [filterChecked, setFilterChecked] = useState([]);
  const [showSidebar, setShowSidebar] = useState(true);
  const [isAiQueryHistory, setAiQueryHistory] = useState(false);
  const [isShareAiText, setShareAiText] = useState(false);
  const [newGroupName, setNewGroupName] = useState("");
  const [newGroupDescription, setNewGroupDescription] = useState("");
  const [isOperationInProgress, setIsOperationInProgress] = useState(false);
  const ongoingRequestRef = useRef(null);
  const { currentUserData } = useAppSelectors();
  const [showInfoMessage, setShowInfoMessage] = useState(true);
  const [filterActive, setFilterActive] = useState(true);
  const [groupActive, setGroupActive] = useState(true);
  const [sidebarLeft, setSidebarLeft] = useState(true);
  const { selectedGroup, switchAccountRefresh, accountLevelPeople, groupList, groupTopicData, currentHomeIndexTab } = useAppSelectors();

  const syncCallBack = () => {
    setSyncing(false);
  };
  useEffect(() => {
    if (navigator.onLine) {
      dispatch(handleScrollToBottom(true));
      dispatch(getProfile());
      dispatch(requestGetAllAcountLevelMember());
    }
  }, [dispatch, switchAccountRefresh]);

  // for by default first group selected
  useEffect(() => {
    if (navigator.onLine) {
      dispatch(handleAppSelectedTopic(null));
      dispatch(handleAppSelectedThread(null));
      dispatch(handleChangeTopicOpen(false));
      dispatch(handleShowAIScreen(false));
      dispatch(handleAppSelectedTopicToSaveMsg(null));
      // handleGetUpdatedMsgData is used for syncing if your application was closed and there is something changed in msg data
      setSyncing(true);
      dispatch(requestGetArchiveGroupList())
      dispatch(handleGetUpdatedMsgData()).then((res) => {
        dispatch(requestallmemberswithgroups({ forceFetch: true })).then(
          async (res) => {
            dispatch(handleAccountSwitchLoading(false));
            if (res?.length > 0) {
              const readAllmsgBody = {
                ref_id: res[0]?.pnId,
              };
              if (res[0]?.messageCount !== 0) {
                // eslint-disable-next-line no-unused-vars
                const res = await dispatch(handleReadAllMsg(readAllmsgBody));
              }
              if (res && res.length > 0 && res[0]?.isGroup) {
                dispatch(getAlltopic({ group_id: res[0]?.id }, true)).then((topicRes) => {
                  // Auto-select first topic or default "General" topic
                  if (topicRes?.data && Array.isArray(topicRes.data) && topicRes.data.length > 0) {
                    dispatch(handleAppSelectedTopic(null));
                    dispatch(handleAppSelectedTopicToSaveMsg(null));
                  } else {
                    dispatch(handleAppSelectedTopic(null));
                    dispatch(handleAppSelectedTopicToSaveMsg(null));
                  }
                });
                dispatch(getAllSubtopicsForGroup(res[0]?.id));
                dispatch(handleAppSelectedSubtopic(null));
                dispatch(handleAppSelectedSubtopicToSaveMsg(null));
                dispatch(saveSelectedAppGroupData(res[0]));
                setisTopicOpen(true);
                dispatch(handleThreadListPanel(true));
                const reqbody = {
                  group_id: res[0]?.id,
                  target_subscriber_id:
                    currentUserData?.activeSubscriber?.id ??
                    res[0]?.subscriberId,
                };
                dispatch(requestgroupMemberDetails(reqbody));
                dispatch(requestGetGroupRecipient(res[0]?.id));
                dispatch(
                  handleFetchMessages(res[0]?.pnId, null, {}, syncCallBack)
                );

                dispatch(handleScrollToBottom(true));
              } else {
                if (res?.length > 0 && !res[0]?.isGroup) {
                  dispatch(saveSelectedAppGroupData(res[0]));
                  dispatch(
                    handleFetchMessages(
                      res[0]?.pnId,
                      0,
                      {
                        type: MessageType?.Direct_Mesage,
                      },
                      syncCallBack
                    )
                  );
                  dispatch(handleGetTempMsgData(res[0]?.pnId));
                  dispatch(handleScrollToBottom(true));
                  setDMuserDetails(res[0]);
                  setisTopicOpen(false);
                  dispatch(handleThreadListPanel(false));
                } else {
                  dispatch(saveSelectedAppGroupData(null));
                  setisTopicOpen(false);
                  dispatch(handleThreadListPanel(false));
                }
              }
            }
          }
        );
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [switchAccountRefresh]);

  const handlegroupItemclick = async (selectedgroup) => {
    // Prevent new clicks if an operation is already in progress
    if (isOperationInProgress) {
      return;
    }
    setIsOperationInProgress(true);

    // Abort any ongoing requests to avoid conflicts
    if (ongoingRequestRef.current) {
      ongoingRequestRef.current.abort();
    }

    // Create a new AbortController for the current request
    const abortController = new AbortController();
    ongoingRequestRef.current = abortController;

    const readAllmsgBody = {
      ref_id: selectedgroup?.pnId,
    };
    setNewMessages("");
    dispatch(handleShowAIScreen(false));
    setAiQueryHistory(false);
    setShareAiText(false);

    if (selectedGroup?.pnId !== selectedgroup?.pnId) {
      setSyncing(true);
      if (selectedgroup?.isGroup) {
        const reqbody = {
          group_id: selectedgroup?.id,
          target_subscriber_id:
            currentUserData?.activeSubscriber?.id ??
            selectedgroup?.subscriberId,
        };
        // Message history/mark-as-read are chat-tab-only concerns — skip them
        // when the click originates from the Track/Performance shared sidebar
        // so a group's unread badge isn't silently cleared without the user
        // actually viewing its chat.
        if (currentHomeIndexTab === 0) {
          dispatch(
            handleFetchMessages(
              selectedgroup?.pnId,
              null,
              {},
              syncCallBack,
              abortController.signal
            )
          );
          dispatch(handleGetTempMsgData(selectedgroup?.pnId));
          if (selectedgroup?.messageCount !== 0) {
            await dispatch(handleReadAllMsg(readAllmsgBody));
          }
        } else {
          setSyncing(false);
        }
        dispatch(requestgroupMemberDetails(reqbody, abortController.signal));
        dispatch(
          requestGetGroupRecipient(selectedgroup?.id, abortController.signal)
        );
        dispatch(
          getAlltopic(
            { group_id: selectedgroup?.id },
            false,
            abortController.signal
          )
        ).then((topicRes) => {

          if (topicRes?.data && Array.isArray(topicRes.data) && topicRes.data.length > 0) {
            dispatch(handleAppSelectedTopic(null));
            dispatch(handleAppSelectedTopicToSaveMsg(null));
          } else {
            // set topic to null beacuse by default it should be all topic means not topic selected
            dispatch(handleAppSelectedTopic(null));
            dispatch(handleAppSelectedTopicToSaveMsg(null));
          }
        }).catch(() => {
          dispatch(handleAppSelectedTopic(null));
          dispatch(handleAppSelectedTopicToSaveMsg(null));
        });
        dispatch(getAllSubtopicsForGroup(selectedgroup?.id, abortController.signal));
        dispatch(handleAppSelectedSubtopic(null));
        dispatch(handleAppSelectedSubtopicToSaveMsg(null));
        dispatch(handleAppSelectedThread(null));
        setDMuserDetails(null);
        setisTopicOpen(true);
        dispatch(handleThreadListPanel(true));
        dispatch(handleScrollToBottom(true));
      } else {
        setDMuserDetails(selectedgroup);
        // Track Work/Performance don't apply to DMs — fall back to Chats.
        if (currentHomeIndexTab !== 0) {
          dispatch(handleHomeTabValue(0));
        }
        if (currentHomeIndexTab === 0) {
          dispatch(
            handleFetchMessages(
              selectedgroup?.pnId,
              null,
              { type: MessageType?.Direct_Mesage },
              syncCallBack,
              abortController.signal
            )
          ).then(() => setSyncing(false));
          dispatch(handleGetTempMsgData(selectedgroup?.pnId));
        } else {
          setSyncing(false);
        }
        dispatch(handleScrollToBottom(true));
        dispatch(handleAppSelectedThread(null));
        setisTopicOpen(false);
        dispatch(handleThreadListPanel(false));
      }
      dispatch(saveSelectedAppGroupData(selectedgroup));
      if (currentHomeIndexTab === 0 && selectedgroup?.messageCount !== 0) {
        await dispatch(handleReadAllMsg(readAllmsgBody));
      }
    }

    setIsOperationInProgress(false);
  };

  const handleFlipToArchiveGroupList = () =>{
    setNewMessages("");
    dispatch(handleShowAIScreen(false));
    setAiQueryHistory(false);
    setShareAiText(false);
    dispatch(handleAppSelectedTopic(null));
    dispatch(handleAppSelectedTopicToSaveMsg(null));
    dispatch(handleAppSelectedThread(null));
    dispatch(saveSelectedAppGroupData(null));
    dispatch(handleThreadListPanel(false));
  }


  const handlecreategroup = async () => {
    if (
      currentUserData?.activePermission === AccountLevelArkchatPermission?.USER
    ) {
      setPermissionModal(true);
    } else {
      // setActiveGroup(null);
      // setisTopicOpen(false);
      await dispatch(requestGetAllAcountLevelMember());
      setCreategroupopen(true);
    }
  };

  const handlecloseCreategroup = () => {
    setNewGroupName("");
    setNewGroupDescription("");
    setCreategroupopen(false);
  };

  const handleSelectedTopic = (topicdetails) => {
    // Prevent new clicks if an operation is already in progress
    if (isOperationInProgress) {
      return;
    }
    setIsOperationInProgress(true);

    // Abort any ongoing requests to avoid conflicts
    if (ongoingRequestRef.current) {
      ongoingRequestRef.current.abort();
    }
    // Create a new AbortController for the current request
    const abortController = new AbortController();
    ongoingRequestRef.current = abortController;
    dispatch(handleAppSelectedTopic(topicdetails));
    dispatch(handleAppSelectedTopicToSaveMsg(topicdetails));
    dispatch(handleAppSelectedSubtopic(null));
    dispatch(handleAppSelectedSubtopicToSaveMsg(null));
    dispatch(
      handleFetchMessages(
        selectedGroup?.pnId,
        topicdetails?.id,
        { topicId: topicdetails?.id },
        null,
        abortController.signal
      )
    );
    setIsOperationInProgress(false);
  };

  const handlesavearkchatgroup = async (reqbody) => {
    if (newGroupName) {
      const response = await dispatch(requestCreateGroupWithmember(reqbody));
      if (response?.code === 200) {
        handlecloseCreategroup();
      }
    } else {
      setRequired(true);
    }
  };

  const handleNameChange = (event) => {
    setNewGroupName(event.target.value);
  };

   const handleDescriptionChange = (event) => {
     setNewGroupDescription(event.target.value);
   };

  return {
    isCreategroupOpen,
    setCreategroupopen,
    setSyncing,
    isSyncing,
    groupname,
    setGroupname,
    newGroupName,
    setNewGroupName,
    newGroupDescription,
    setNewGroupDescription,
    isRequired,
    setRequired,
    dmUserDeatils,
    setDMuserDetails,
    dispatch,
    isTopicOpen,
    setisTopicOpen,
    isMoveTopicTriggered,
    setMoveTopicTriggered,
    moveTopicMsgId,
    setMoveTopicMsgId,
    isPermissionModalOpen,
    setPermissionModal,
    newMessages,
    setNewMessages,
    filterChecked,
    setFilterChecked,
    currentHomeIndexTab,
    showSidebar,
    setShowSidebar,
    setAiQueryHistory,
    isShareAiText,
    setShareAiText,
    isAiQueryHistory,
    currentUserData,
    accountLevelPeople,
    groupList,
    groupTopicData,
    handlegroupItemclick,
    handleFlipToArchiveGroupList,
    handlecreategroup,
    handlecloseCreategroup,
    handleNameChange,
    handleDescriptionChange,
    handlesavearkchatgroup,
    handleSelectedTopic,
    showInfoMessage,
    setShowInfoMessage,
    filterActive,
    setFilterActive,
    groupActive,
    setGroupActive,
    sidebarLeft,
    setSidebarLeft
  };
};

export default useChatState;
